module.exports = __webpack_public_path__ + "static/media/bna.ad28a6fc.jpeg";